export default __webpack_public_path__ + "static/media/05_motor_Cadenas.3e5e5faa.svg";